import { IconComponentStyled } from '@procurify/ui'
import styled from 'styled-components'

const OPACITY_TRANSITION_MS = 100
const TRANSFORM_TRANSITION_MS = 120
const TRANSITION_DELAY_MS = 100

export const AppHeaderIntercomLauncherIconStyled = styled.span<{
  $isOpen: boolean
}>`
  display: grid;
  place-items: center;

  ${IconComponentStyled} {
    grid-area: 1 / 1;
    transition:
      opacity ${OPACITY_TRANSITION_MS}ms ease-in-out,
      transform ${TRANSFORM_TRANSITION_MS}ms ease-in;
  }

  ${IconComponentStyled}:first-child {
    opacity: ${(props) => (props.$isOpen ? 0 : 1)};
    transition-delay:
      ${(props) =>
        props.$isOpen
          ? `${TRANSITION_DELAY_MS}ms`
          : `${TRANSFORM_TRANSITION_MS + 2 * TRANSITION_DELAY_MS}ms`},
      ${TRANSITION_DELAY_MS}ms;
  }

  ${IconComponentStyled}:last-child {
    opacity: ${(props) => (props.$isOpen ? 1 : 0)};
    transform: rotate(${(props) => (props.$isOpen ? '90deg' : '0deg')});
    transition-delay:
      ${(props) =>
        props.$isOpen
          ? `${TRANSITION_DELAY_MS}ms`
          : `${TRANSFORM_TRANSITION_MS + 2 * TRANSITION_DELAY_MS}ms`},
      ${(props) =>
        props.$isOpen
          ? `${OPACITY_TRANSITION_MS + 2 * TRANSITION_DELAY_MS}ms`
          : `${TRANSITION_DELAY_MS}ms`};
  }

  @media (prefers-reduced-motion: reduce) {
    ${IconComponentStyled} {
      transition-duration: 0ms;
    }
  }
`
